import React, { useState } from 'react';
import { FiLock, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import AdminJsonUpload from './AdminJsonUpload';
import AdminLogin from './AdminLogin';
import AdminStatsCards from './AdminStatsCards';
import { getStoredDraws } from '../utils/drawStorage';
import { getGenerationStats } from '../utils/generationTracker';

function AdminModal({ isOpen, onClose }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [stats, setStats] = useState(getGenerationStats);
  const [drawsCount, setDrawsCount] = useState(() => getStoredDraws().length);

  if (!isOpen) return null;

  const refreshStats = () => {
    setStats(getGenerationStats());
  };

  return (
    <div className="admin-overlay" role="dialog" aria-modal="true">
      <div className="admin-modal-card">
        <div className="admin-modal-top">
          <div className="admin-tag">
            <SafeIcon icon={FiLock} />
            PANOU DE ADMINISTRARE
          </div>
          <button type="button" className="close-btn" onClick={onClose} aria-label="Închide">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        {!isAuthenticated ? (
          <AdminLogin onAuthenticated={() => setIsAuthenticated(true)} />
        ) : (
          <div className="admin-dashboard-body">
            <div className="admin-section-header">
              <h3>STATISTICI GENERATOR & ACTIVITATE</h3>
              <button type="button" onClick={refreshStats} className="btn-secondary-sm">
                REÎNCARCĂ METRICI
              </button>
            </div>

            <AdminStatsCards stats={stats} />

            <AdminJsonUpload
              totalDraws={drawsCount}
              onDbUpdated={(newTotal) => setDrawsCount(newTotal)}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminModal;